import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AgencySettingsComponent } from './agency-settings.component';


const routes: Routes = [ 
  {
  path: '',
  component: AgencySettingsComponent,

}]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgencySettingsRoutingModule { }
